exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.publish-item[data-v-6c0f3bad]:hover {\n  background-color: #212121;\n  cursor: pointer;\n}\n.h14rem[data-v-6c0f3bad] {\n  height: 14rem;\n}\n.mb-custom-px[data-v-6c0f3bad] {\n  margin-bottom: 12px;\n}\n.lh-13[data-v-6c0f3bad] {\n  line-height: 1.3;\n}\n.custom-font-size[data-v-6c0f3bad] {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.3;\n}\n", ""]);

// exports
